<template>
  <h1>{{ $t('menu.pim.subpages.productsContent.header')}} ({{ this.hotSettings.data.length }})</h1>
  <div class="pb-4">
    <button class="appButton mt-2" @click="this.$router.push('/pim')">{{ $t('menu.pim.subpages.productsContent.back')
      }}</button>
    <button class="appButton mt-2" @click="refresh()">{{ $t('menu.pim.subpages.productsContent.refresh')
      }}</button>
  </div>
  <div
    class="mb-4 rounded-md"
    :style="missingTagsRows.length === 0
      ? 'background: #142218; border: 1px solid rgba(74,222,128,0.3);'
      : 'background: #2a2410; border: 1px solid rgba(250,204,21,0.3);'"
  >
    <div
      class="p-3 flex items-center cursor-pointer select-none"
      @click="missingTagsExpanded = !missingTagsExpanded"
    >
      <span class="mr-2">{{ missingTagsExpanded ? '▼' : '▶' }}</span>
      <span>{{ $t('menu.pim.subpages.productsContent.missingTags') }}:</span>
      <span class="ml-2 font-semibold" :class="missingTagsRows.length === 0 ? 'text-green-400' : 'text-yellow-400'">
        {{ missingTagsRows.length }}
      </span>
    </div>
    <div v-if="missingTagsExpanded && missingTagsRows.length > 0" class="px-3 pb-3">
      <table class="w-full text-sm">
        <thead>
          <tr class="text-left" style="border-bottom: 1px solid rgba(255,255,255,0.1);">
            <th class="py-2 pr-4">SKU</th>
            <th class="py-2 pr-4">Title</th>
            <th class="py-2 pr-4">Status</th>
            <th class="py-2 pr-4">Tags</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in missingTagsRows" :key="row[0]" style="border-bottom: 1px solid rgba(255,255,255,0.05);">
            <td class="py-1 pr-4">{{ row[1] }}</td>
            <td class="py-1 pr-4">{{ row[2] }}</td>
            <td class="py-1 pr-4">{{ row[3] }}</td>
            <td class="py-1 pr-4">{{ row[4] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div
    class="mb-4 rounded-md"
    :style="missingTapShopRows.length === 0
      ? 'background: #142218; border: 1px solid rgba(74,222,128,0.3);'
      : 'background: #2a2410; border: 1px solid rgba(250,204,21,0.3);'"
  >
    <div
      class="p-3 flex items-center cursor-pointer select-none"
      @click="missingTapShopExpanded = !missingTapShopExpanded"
    >
      <span class="mr-2">{{ missingTapShopExpanded ? '▼' : '▶' }}</span>
      <span>{{ $t('menu.pim.subpages.productsContent.missingTapShop') }}:</span>
      <span class="ml-2 font-semibold" :class="missingTapShopRows.length === 0 ? 'text-green-400' : 'text-yellow-400'">
        {{ missingTapShopRows.length }}
      </span>
    </div>
    <div v-if="missingTapShopExpanded && missingTapShopRows.length > 0" class="px-3 pb-3">
      <table class="w-full text-sm">
        <thead>
          <tr class="text-left" style="border-bottom: 1px solid rgba(255,255,255,0.1);">
            <th class="py-2 pr-4">SKU</th>
            <th class="py-2 pr-4">Title</th>
            <th class="py-2 pr-4">Status</th>
            <th class="py-2 pr-4">Tags</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in missingTapShopRows" :key="row[0]" style="border-bottom: 1px solid rgba(255,255,255,0.05);">
            <td class="py-1 pr-4">{{ row[1] }}</td>
            <td class="py-1 pr-4">{{ row[2] }}</td>
            <td class="py-1 pr-4">{{ row[3] }}</td>
            <td class="py-1 pr-4">{{ row[4] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="flex">
    <div class="w-full">
      <hot-table :settings="hotSettings"></hot-table>
    </div>
  </div>

</template>

<script>
import { useSettings } from '@/store/user'
import mixins from '@/components/mixins';
import { HotTable } from '@handsontable/vue3';
import { registerAllModules } from 'handsontable/registry';
import 'handsontable/dist/handsontable.full.css';

// register Handsontable's modules
registerAllModules();

export default {
    mixins: [mixins],
    setup() {
        const user = useSettings();

        return { user }
    },
    created() {
      this.hotSettings.data = this.user.pim.products.map(product => {
        return [product.id, product.sku, product.title, product.status, product.tags, product.description, product.internal_comment];
      });
    },
    components: {
      HotTable,
    },
    computed: {
      missingTagsRows() {
        return this.hotSettings.data.filter(row => {
          const status = (row[3] || '').toString().toUpperCase();
          const tags = row[4];
          const tagsEmpty = tags === null || tags === undefined || tags.toString().trim() === '';
          return status === 'ACTIVE' && tagsEmpty;
        });
      },
      missingTapShopRows() {
        return this.hotSettings.data.filter(row => {
          const tags = (row[4] || '').toString().toLowerCase();
          const list = tags.split(',').map(t => t.trim());
          return !list.includes('tap-shop');
        });
      }
    },
    data() {
      return {
        missingTagsExpanded: false,
        missingTapShopExpanded: false,
        hotSettings: {
          data: [],
          height: 'auto',
          filters: false,
          manualRowMove: false,
          dropdownMenu: false,
          // hiddenColumns: {
          //   columns: [0],
          //   indicators: false
          // },          
          autoWrapRow: true,
          autoWrapCol: true,
          fillHandle: true,
          rowHeaders: true,
          colHeaders: ['ID', 'SKU', 'Title', 'Status', 'Tags', 'Description', 'Comment'],
          columns: [
            { data: 0, name: 'id', type: 'numeric', editor: false},
            { data: 1, name: 'sku', type: 'text', editor: false},
            { data: 2, name: 'title', type: 'text', editor: false},
            { data: 3, name: 'status', editor: false},
            { data: 4, name: 'tags', type: 'text'},
            { data: 5, name: 'description', namespace: 'custom', field_type: 'rich_text_field', type: 'text'},
            { data: 6, name: 'internal_comment', namespace: 'custom', field_type: 'single_line_text_field', type: 'text'},
          ],
          // licenseKey: '53013-4578b-9e935-c450e-92257',
          licenseKey: 'non-commercial-and-evaluation',
          afterChange: (changes) => {
            changes?.forEach(([row, prop, oldValue, newValue]) => {
              
              // extract the Shopify ID from the product ID
              const match = this.user.pim.products[row].id.match(/gid:\/\/shopify\/Product\/(\d+)/);
              const Shopify_id = match ? match[1] : null;

              const field = this.hotSettings.columns[prop].name;
              const field_type = this.hotSettings.columns[prop].field_type || 'single_line_text_field';
              const namespace = this.hotSettings.columns[prop].namespace || 'custom';

              const obj = {
                productId: Shopify_id,
                metafield: field,
                value: newValue,
                type: field_type,
                namespace: namespace
              };
              
              this.user.updateProductPim(obj);
            });
          }
        },
      };
    },
    methods: {
       refresh() {
        this.hotSettings.data = [];
        this.user.getProductsPim().then(() => {
           this.hotSettings.data = this.user.pim.products.map(product => {
             return [product.id, product.sku, product.title, product.status, product.tags, product.description, product.internal_comment];
           });
         });
      }       
    }
};

</script>